// extracted by mini-css-extract-plugin
export default {"IconButton_0":"SubmitButton-module__IconButton_0--AJwMO"};